const SurveyStatuses = {
    active: 'active',
    done: 'done',
} as const;

export default SurveyStatuses;
